import React, { useState } from "react";
import { Buffer } from "buffer";
import { Activity } from "lucide-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoginApi from "../../services/LoginApi";
import { Button } from "components/ui/button";
import { Input } from "components/ui/input";
import { Card, CardContent, CardHeader, CardTitle } from "components/ui/card";

function Login() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const handleLogin = async () => {
        const trimmedUsername = username.trim();
        const trimmedPassword = password.trim();
        if (!trimmedUsername || !trimmedPassword) {
            toast.error("Username and password are required");
            return;
        }

        const credential = Buffer.from(`${trimmedUsername}:${trimmedPassword}`).toString('base64');
        let response = await LoginApi(credential)
        if (response) {
            localStorage.setItem('credential', credential);
            window.location.reload();
        } else {
            toast.error("Invalid credentials");
        }
    };

    return (
        <div className="flex min-h-screen items-center justify-center bg-background px-4">
            <Card className="w-full max-w-sm">
                <CardHeader className="items-center text-center">
                    <span className="mx-auto flex h-11 w-11 items-center justify-center rounded-xl bg-primary/15 text-primary">
                        <Activity className="h-6 w-6" strokeWidth={2.5} />
                    </span>
                    <CardTitle className="text-xl">Health Check</CardTitle>
                    <p className="text-sm text-muted-foreground">Sign in to continue</p>
                </CardHeader>
                <CardContent className="space-y-4">
                    <div className="space-y-1.5">
                        <label htmlFor="username" className="text-sm font-medium">Username</label>
                        <Input
                            id="username"
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                    </div>
                    <div className="space-y-1.5">
                        <label htmlFor="password" className="text-sm font-medium">Password</label>
                        <Input
                            id="password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    <Button className="w-full" onClick={handleLogin}>Login</Button>
                </CardContent>
            </Card>
        </div>
    );
}

export default Login;
